import socialservice from "../../../view/pages/admin/whatsapp/socialservice";

const state = {
  socialNetworks: [],
  activeSocial: null,
  packs: {
    packs: [],
    userPacks: [],
  },
  loading: false,
  socialNetworksAdmin: [],
};

const getters = {
  socialNetworks: (state) => state.socialNetworks,
  activeSocial: (state) => state.activeSocial,
  packs: (state) => state.packs,
  whatsappNetwork: (state) =>
    state.socialNetworks.find((s) => s.name_en === "whatsApp"),
  socialNetworksAdmin: (state) => state.socialNetworksAdmin,
};

const mutations = {
  SET_SOCIAL_NETWORKS(state, networks) {
    state.socialNetworks = networks;
  },
  SET_ACTIVE_SOCIAL(state, social) {
    state.activeSocial = social;
  },
  SET_PACKS(state, packs) {
    state.packs = packs;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_SOCIALNETWORK_ADMIN(state, networks) {
    state.socialNetworksAdmin = networks;
  },
};

const actions = {
  async fetchSocialNetworks({ commit }) {
    commit("SET_LOADING", true);
    try {
      const { data } = await socialservice.getSocialNetworks();
      commit("SET_SOCIAL_NETWORKS", data.data);
      return data.data;
    } catch (error) {
      console.error("Error fetching social networks:", error);
      throw error;
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async saveSocialData({ commit }, { socialId, packId, data }) {
    try {
      const response = await socialservice.saveSocialData(
        socialId,
        packId,
        data,
      );
      return response.data;
    } catch (error) {
      console.error("Error saving social data:", error);
      throw error;
    }
  },
    async saveSocialDataBale({ commit }, { socialId, user_id, status, data, expire_at, max_sends }) {
    try {
      const response = await socialservice.saveSocialDataBale(socialId, user_id, status, data, expire_at, max_sends);
      return response.data;
    } catch (error) {
      console.error("Error saving social data:", error);
      throw error;
    }
  },

  async getWhatsappDataAdmin({ commit }) {
    try {
      commit("SET_LOADING", true);
      const response = await socialservice.getWhatsappAdmin();
      commit("SET_SOCIALNETWORK_ADMIN", response.data);
      return response.data;
    } catch (error) {
      console.error("Error saving social data:", error);
      throw error;
    } finally {
      commit("SET_LOADING", false);
    }
  },
  async sendSocialMessage({ commit }, messageData) {
    try {
      const response = await socialservice.sendSocialMessage(messageData);
      return response.data;
    } catch (error) {
      console.error("Error sending social message:", error);
      throw error;
    }
  },

  async fetchSocialPacks({ commit }, socialId) {
    try {
      const { data } = await socialservice.getSocialPacks(socialId);
      commit("SET_PACKS", data.data);
      return data.data;
    } catch (error) {
      console.error("Error fetching social packs:", error);
      throw error;
    }
  },
  async buySocialPack({ commit }, socialpackId) {
    try {
      const { data } = await socialservice.buySocialPack(socialpackId);
      return data;
    } catch (error) {
      console.error("Error fetching social packs:", error);
      throw error;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
